import React from 'react';
import './Skills.css';

const Skills = () => {
  const skills = {
    'Programming': ['Python', 'C++', 'Java'],
    'Machine Learning & AI': ['Deep Learning', 'Model Training', 'Fine-Tuning', 'RAG', 'Agentic AI'],
    'Tools & Frameworks': ['PyTorch', 'TensorFlow', 'Scikit-learn', 'Pandas', 'NumPy', 'Docker', 'Lanchain and LangGraph', 'MCP', 'REST API', 'FastAPI', 'Neo4j', 'Vector Databases','Git']
  };

  return (
    <div className="skills">
      <h2 className="section-title">Skills</h2>
      <div className="skills-grid">
        {Object.entries(skills).map(([category, items]) => (
          <div key={category} className="skill-card">
            <h3>{category}</h3>
            <div className="skill-items">
              {items.map((skill) => (
                <div key={skill} className="skill-item">{skill}</div>
              ))}
            </div>
          </div>
        ))}
      </div>
      
      <div className="tech-stack-icons">
        <h3>Tech Stack</h3>
        <div className="icons-container">
          <a href="https://www.java.com/" target="_blank" rel="noopener noreferrer">
            <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg" alt="Java" />
          </a>
          <a href="https://python.org/" target="_blank" rel="noopener noreferrer">
            <img src="https://upload.wikimedia.org/wikipedia/commons/c/c3/Python-logo-notext.svg" alt="Python" />
          </a>
          <a href="https://pandas.pydata.org/" target="_blank" rel="noopener noreferrer">
            <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/pandas/pandas-original.svg" alt="Pandas" />
          </a>
          <a href="https://numpy.org/" target="_blank" rel="noopener noreferrer">
            <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/numpy/numpy-original.svg" alt="NumPy" />
          </a>
          <a href="https://matplotlib.org/" target="_blank" rel="noopener noreferrer">
            <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/matplotlib/matplotlib-original.svg" alt="Matplotlib" />
          </a>
          <a href="https://scikit-learn.org/" target="_blank" rel="noopener noreferrer">
            <img src="https://upload.wikimedia.org/wikipedia/commons/0/05/Scikit_learn_logo_small.svg" alt="scikit-learn" />
          </a>
          <a href="https://pytorch.org/" target="_blank" rel="noopener noreferrer">
            <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/pytorch/pytorch-original.svg" alt="PyTorch" />
          </a>
          <a href="https://flask.palletsprojects.com/" target="_blank" rel="noopener noreferrer">
            <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/flask/flask-original.svg" alt="Flask" />
          </a>
          <a href="https://fastapi.tiangolo.com/" target="_blank" rel="noopener noreferrer">
            <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/fastapi/fastapi-original.svg" alt="FastAPI" />
          </a>
          <a href="https://www.docker.com/" target="_blank" rel="noopener noreferrer">
            <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original.svg" alt="Docker" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Skills;
